//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    full: {
      type: Boolean,
      default: false,
    },
  },
}
